// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/CustomerGroup.yaml
// Generated: 2026-07-10T09:16:22.894Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateCustomerGroup, UpdateCustomerGroup, CustomerGroup } from '@/types/sales/CustomerGroup';

/**
 * CustomerGroup Service
 * CRUD operations for CustomerGroup via the ABP API.
 */
export const customerGroupService = new EntityService<CustomerGroup, CreateCustomerGroup, UpdateCustomerGroup>(
  '/api/sales/customergroup',
  'CustomerGroup',
);
